import React from 'react';
import UnderConstruction from '../../component/ui/Common/UnderConstruction';
import styles from './DBHealth.module.scss';

const PostgreSQL = () => {
  return (
    <div className={styles.mariadbPage}>
      <div className="page-title p-16">PostgreSQL</div>
      
      {/* 실제 페이지 콘텐츠 - 배경으로 보임 */}
      <div className={styles.mariadbContent}>
        <h2>PostgreSQL 모니터링</h2>
        <p>이 페이지에서는 PostgreSQL 데이터베이스의 성능 및 상태를 모니터링할 수 있습니다.</p>
        
        {/* 더미 콘텐츠 */}
        <div className={styles.statsContainer}>
          <div className={styles.statCard}>
            <h3>Connection Status</h3>
            <div className={styles.statValue}>- / -</div>
          </div>
          <div className={styles.statCard}>
            <h3>Query Performance</h3>
            <div className={styles.statValue}>- ms</div>
          </div>
          <div className={styles.statCard}>
            <h3>Database Size</h3>
            <div className={styles.statValue}>- GB</div>
          </div>
        </div>
      </div>
      
      {/* 공사중 표시 오버레이 */}
      <UnderConstruction />
    </div>
  );
};

export default PostgreSQL;